<template>
  <div class="layout-wrapper">
    <div class="country-select-wrapper">
      <h1>{{$t('country.heading')}}</h1>
      <p class="info">
        {{$t('country.info')}}
      </p>
      <contry-select />
    </div>
    <div class="loading-placeholder" v-show="showLoading">
      <loading-symbol>{{$t('common.loading')}}</loading-symbol>
    </div>
    <div v-show="!showLoading">
      <online-issuing />
      <pos-list />
      <not-available-info />
    </div>
  </div>
</template>

<style scoped>
  .layout-wrapper {
    padding: 16px;
    color: #2c3e50;
    font-family: "Roboto", sans-serif;
    font-size: 14px;
  }
  .online-issuing-wrapper {
    margin-top: 32px;
  }
  .pos-list-wrapper {
    margin-top: 32px;
  }
  h1 {
    margin-bottom: 24px;
  }
  .info {
    margin-bottom: 24px;
  }
  .loading-placeholder {
    min-height: 500px;
    margin-top: 48px;
    color: #40b8b8;
    font-size: 24px;
    font-weight: bold;
  }
</style>

<script>
import { mapGetters } from 'vuex';
import ContrySelect from './CountrySelect.vue';
import OnlineIssuing from './OnlineIssuing.vue';
import PosList from './PosList.vue';
import NotAvailableInfo from './NotAvailableInfo.vue';
import LoadingSymbol from './identifiers/LoadingSymbol.vue';

export default {
  name: 'widget-layout',
  computed: {
    ...mapGetters({
      getLoading: 'getLoading',
    }),
    showLoading() {
      return this.getLoading === true;
    },
  },
  components: {
    ContrySelect,
    OnlineIssuing,
    PosList,
    NotAvailableInfo,
    LoadingSymbol,
  },
};
</script>
